// maintain alphabetical order
export const jaDashboard = {
  DashboardSnackbarErrorFindingMaxDates: '最大日付の検索中にエラーが発生しました。ライブデータなしで読み込み中です。',
  DashboardSnackbarErrorRefreshingData: 'データの更新中にエラーが発生しました。データは最後に {{timestamp}} に正常に更新されました。',
  DashboardTooltipClickToPause: 'クリックすると一時停止します。',
  DashboardTooltipClickToStart: 'クリックして開始します。',
  DashboardTooltipComparisonData: '比較データの表示 / 非表示',
  DashboardTooltipDownloadCSV: 'チャートデータを CSV でダウンロード',
  DashboardTooltipExcludeToday: 'この切り替えは、日付範囲として過去 7 日間または過去 30 日間が選択されている場合にのみ使用できます。',
  DashboardTooltipLastUpdatedTime: '最終更新日: {{timestamp}}',
};
